import { css } from '@emotion/react';
import { PageLayout } from '../../Layout';
import { TYPOGRAPHY2 } from '../../Styles';

const FAILURE_PAGE_STYLE = css`
  label: FAILURE_PAGE_STYLE;
  text-align: center;
  ${TYPOGRAPHY2.xLargeBold}
`;

export const GenericFailurePage = ({ errorInfo }: { errorInfo: string | null }) => {
  return (
    <PageLayout title='Unable to load page' contentLayoutStyling='standard'>
      <div css={FAILURE_PAGE_STYLE}>Error: {errorInfo || 'Unknown error'}</div>
    </PageLayout>
  );
};
